<div class="container-fluid">
  <div class="row ">
    <div class="col-md-12">
      <div id="civil-cart-header">
         <span id="civil-cart-title"><i class="glyphicon glyphicon-shopping-cart"></i> Cart</span>
      </div>
      <div id="civil-cart-contents">
      <form #courtCasesForm [formGroup]="courtCasesFormGroup" autocomplete="off">
        <div *ngIf="getCartContents().length > 0">
          <div [formArrayName]="'cases'" [class.invalid]="!courtCasesFormGroup.controls.selectedCases.valid">
            <p id="civil-cart-select-instruction-para">Select one or more cases to print or email.</p>
            <div id="cart-search-result-table-div" class="table-responsive" *ngIf="getCartContents().length > 0">          
              <table id="cart-search-result-table" class="table full-width table-hover table-condensed table-nowrap">
                <thead>
                  <tr>
                    <th width="5%"><br><input type="checkbox" title="click to select/unselect all" [checked]="cartService.areAllSelected()" (change)="toggleMassSelection()"></th>
                    <th width="9%">County<br>Case Number <span [popover]="popTemplateForCounty" placement="auto" popoverTitle="County and Case Number" (mouseover)="popOverHandler('onShow')" (mouseleave)="popOverHandler('onHide')"><i class="fa fa-info-circle"></i></span></th>
                    <th width="9%">Case Type <span popover="This is a description of the case type.  Case types can be: Civil District, Civil Superior, Small Claims, Criminal District, Criminal Superior, Estates, Special Proceedings, or Registrations." popoverTitle="Case Type" (mouseover)="popOverHandler('onShow')" (mouseleave)="popOverHandler('onHide')"><i class="fa fa-info-circle"></i></span></th>
                    <th width="31%">Caption <span popover="The Case Caption shows the names of the BY and AGAINST parties on the case. Only the first BY and first AGAINST parties named in the case are reported on this line." popoverTitle="Caption" (mouseover)="popOverHandler('onShow')" (mouseleave)="popOverHandler('onHide')"><i class="fa fa-info-circle"></i></span></th>
                    <th width="12%">Pleadings and Issues <span popover="An issue can exist without a party." popoverTitle="Pleadings and Issues" (mouseover)="popOverHandler('onShow')" (mouseleave)="popOverHandler('onHide')"><i class="fa fa-info-circle"></i></span></th>
                    <th width="11%">Case Status <span [popover]="popTemplateForStatus" popoverTitle="Case Status" (mouseover)="popOverHandler('onShow')" (mouseleave)="popOverHandler('onHide')"><i class="fa fa-info-circle"></i></span></th>
                    <th width="12%">Judgment <span popover="A YES in this field indicates there are judgments associated with the case." popoverTitle="Judgment Indexed" (mouseover)="popOverHandler('onShow')" (mouseleave)="popOverHandler('onHide')"><i class="fa fa-info-circle"></i></span></th>
                    <th width="11%">Actions <span [popover]="popTemplateForAction" popoverTitle="Actions" (mouseover)="popOverHandler('onShow')" (mouseleave)="popOverHandler('onHide')"><i class="fa fa-info-circle"></i></span></th>
                  </tr>
                </thead>
                <tbody id="cart-search-result-table-tbody">
                  <ng-container *ngFor="let case of courtCasesFormGroup.controls['cases'].controls; let i = index; ">
                  <tr id="{{'cart-case-row-'+ i + '-table-tr-for-case-info'}}" 
                      [formGroup]="case" 
                      (click)="onViewCaseSelected(case.controls.caseIdentifier.value)"
                      (mouseover)="onMouseOverCase(i);" 
                      (mouseleave)="onMouseOffCase(i);" 
                      [class.highlighted-bgcolor]="(mouseOverCaseFlags[i])">   
                    <td id="{{'cart-case-row-' + i + '-sel-checkbox'}}"  
                        width="5%"
                       (click)="$event.stopPropagation()">
                      <input type="checkbox" 
                             title="click to select"
                             formControlName="caseChecked"
                             [checked]="caseRowSelectedFlags[i]"
                             (change)="toggleCaseSelection(case.controls.caseIdentifier.value, $event)"  
                             id="case_{{i +'__' + case.controls.county.value }}">
                    </td>
                    <td id="{{'cart-case-row-' + i + '-case-county-and-case-number'}}" 
                        width="9%"
                        title="Click for case summary."><span title="{{ case.controls.county.value + ' ' + case.controls.caseNumber.value  }}" >{{ case.controls.county.value }}<br>{{ case.controls.caseNumber.value }}</span></td>
                    <td id="{{'cart-case-row-' + i + '-case-type'}}" 
                        width="9%"
                        title="Click for case summary."><span title="{{ case.controls.caseType.value }}" >{{ case.controls.caseType.value }}</span></td>
                    <td id="{{'cart-case-row-' + i + '-case-caption'}}"
                        width="31%"
                        title="Click for case summary."><span title="{{ case.controls.caseCaption.value }}" >{{ case.controls.caseCaption.value }}</span></td>
                    <td id="{{'cart-case-row-' + i + '-case-pleadings-issues'}}"
                        width="12%"
                        title="Click for case summary."
                         (click)="$event.stopPropagation()">
                       <a id="{{'cart-case-row-'+ i + '-case-pleadings-issues-show-lnk'}}"
                          title="Click for showing pleadings and issues" (click)="showPleading(i);" *ngIf="!pleadingShowFlags[i]" >
                          <span  class="glyphicon glyphicon-plus glyphicon-percent-80"></span><span>Show </span>
                       </a>
                       <a id="{{'cart-case-row-'+ i + '-case-pleadings-issues-hide-lnk'}}"
                          title="Click for hiding pleadings and issues" (click)="hidePleading(i);" *ngIf="pleadingShowFlags[i]">
                          <span class="glyphicon glyphicon-minus"></span><span>Hide</span>
                       </a>
                    </td>
                    <td id="{{'cart-case-row-' + i + '-case-status'}}"
                        width="11%"
                        title="Click for case summary."><span title="{{ case.controls.caseStatusDescription.value }}" >{{ case.controls.caseStatusDescription.value }}</span></td>
                    <td id="{{'cart-case-row-' + i + '-case-judgment'}}"
                        width="12%"
                        title="Click for case summary."><span title="{{ case.controls.judgmentDocketedAndIndexed.value }}">{{ case.controls.judgmentDocketedAndIndexed.value }}</span></td>
                    <td id="{{'cart-case-row-' + i + '-case-action'}}" 
                        width="11%"
                       (click)="$event.stopPropagation()" >
                     <a id="civil-cart-view-case"
                        title="Click for Case View" 
                        (click)="onViewCaseSelected(case.controls.caseIdentifier.value)">
                         <span class="glyphicon glyphicon-folder-open"></span> View Case
                     </a>
                    <br>
                     <a>
                      <span class="glyphicon glyphicon-shopping-cart"></span>
                      <span id="civil-cart-remove" title="Remove from Cart" *ngIf="isCaseInCart(case.controls.caseIdentifier.value)" (click)="removeCaseFromCart(case.controls.savedCase.value)">Remove</span>
                     </a>
                    </td>
                  </tr>
                  <tr id="{{'cart-case-row-'+ i + '-table-tr-for-case-pleadings-issues'}}" 
                      title="Click for Case View" 
                      (click)="onViewCaseSelected(case.controls.caseIdentifier.value)"
                      (mouseover)="onMouseOverCase(i);" 
                      (mouseleave)="onMouseOffCase(i);" 
                      [class.highlighted-bgcolor]="(mouseOverCaseFlags[i])" 
                       *ngIf="pleadingShowFlags[i]">
                    <td width="24%" colspan="3" id="{{'cart-case-row-'+ i + '-table-td-for-pleadings-blanks'}}"></td> 
                    <td width="76%" colspan="5" id="{{'cart-case-row-'+ i + '-table-td-for-pleadings-wrapper'}}">
                        <app-cart-pleads-grid
                          [case]="getCartContents()[i]"  
                          [caseRowIndex]="i" 
                          [rowBeingShown]="pleadingShowFlags[i]"
                          [rowToBeHidden]="pleadingHideNotifyFlags[i]"
                          [bgHighlighted]="(mouseOverCaseFlags[i])" 
                          [maxDisplayRows]="6"
                          (onPleadingClosed)="onPleadingClosed($event);"></app-cart-pleads-grid>
                    </td>
                  </tr>
                  </ng-container>
                </tbody>
              </table>
            </div>
            <div class="spacer" id="civil-cart-slection-links-div">
              <a class="anchor" id="civil-cart-select-all" (click)="selectAll()">select all</a> | <a class="anchor" id="civil-cart-deselect-all" (click)="deselectAll()">deselect all</a>           
            </div>
            <div class="text-left" id="civil-cart-action-buttons-div">
                <button class="btn btn-primary" (click)="openEmail()" id="cart-email-button">Email&nbsp;&nbsp;<span class="glyphicon glyphicon-envelope"></span></button>
                <button class="btn btn-primary" (click)="openPrint()" id="cart-print-button">Print&nbsp;&nbsp;<span class="glyphicon glyphicon-print"></span></button>           
                <div class=" pull-right">
                  <button class="btn btn-primary" (click)="openDiscardAllInCart()" id="cart-discardall-button">Discard All</button>
                  <button class="btn btn-primary" (click)="hideModal()" id="cart-close-button">Close</button>
                </div>
            </div>
            <div id="civil-cart-error-msgs-div" class="control-label has-error" *ngIf="(submitted && !courtCasesFormGroup.controls.selectedCases.valid)">
                    <p></p>
                    <p id="cart-error-message">Please select one or more cases to email or print.</p>
            </div>
          </div>
        </div>
      </form>
      </div>        
      <div *ngIf="getCartContents().length === 0">
        <div>
          <p><b>You have not yet added any court cases to your cart.</b></p>
          <p><u>What can I do here?</u></p>
          <p>Your cart holds the court cases you've added for later viewing, printing and emailing.</p>
          <p>To add a case to your cart, click the "Add to Cart" link in the search result row for each case or the "<i class="glyphicon glyphicon-shopping-cart"></i> Add to Cart" button while viewing a Case Summary.</p>
          <p>All cases collected in your cart will be discarded when you select "Clear History" or if the application sits idle for more than 10 minutes.</p>
        </div>
        <div>
         <button class="btn btn-primary" (click)=hideModal() id="cart-close-button">Close</button>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="modal fade" bsModal #discardAllModal="bs-modal" [config]="{backdrop: 'static'}"
        tabindex="-1" role="dialog" aria-labelledby="mySmallModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-sm">
    <div class="modal-content">
      <div class="modal-header-no-banner" id="briefcase-discard-modal">
        <h3 class="modal-title" style="height: 40px">Discard All?</h3>
      </div>
      <div class="modal-body">
        This will remove all data in your cart. This action cannot be undone.
      </div>
      <div class="modal-footer">
        <div class="pull-left">
          <button class="btn btn-primary btn-ciprs" (click)="discardAll()" id="clearbutton">Discard</button>
          <button class="btn btn-primary btn-ciprs" (click)="discardAllModal.hide()" id="dontclearbutton">Don't discard</button>
        </div>
      </div>
    </div>
  </div>
</div>
<ng-template #popTemplateForCounty>
  <div class="popover-section">The Case County is the county where the case was issued.</div>
  <div class="popover-section">The Case File Number consists of ‘YY&lt;casetype&gt;######’</div>
  <div class="popover-section">where: </div>
  <div class="popover-section">YY – two-digit year when case began (i.e. if a case began in 2005 then YY = 05)</div>
  <div class="popover-section">&lt;casetype&gt; - two or three character code for the type of case (i.e., ‘CVD’ for Civil District, ‘E’ for Estates, ‘CR’ for Criminal, etc.)</div>
  <div class="popover-section">‘######’ - sequence number for case filed.</div>
</ng-template>
<ng-template #popTemplateForStatus>
  <div>Indicates the status of the case.
    <div class="popover-section"><b>NO PENDING ISSUES</b>- All issues on the case have an order result other than PENDING ORDER and there is no appeal on the case.</div>
    <div class="popover-section"><b>PENDING ISSUE(S)</b> - Any issue on the case has either no order result or an order result of PENDING ORDER and there is no appeal on the case.</div>
    <div class="popover-section"><b>APPEALED</b> - All issues on the case have an order result other than PENDING ORDER but there is an appeal on the case.</div>
    <div class="popover-section"><b>PENDING ISSUE(S)/APPEALED</b> - Any issue on the case has either no order result or an order result of PENDING ORDER and there is an appeal on the case.</div>
  </div>
</ng-template>
<ng-template #popTemplateForAction>
  <div class="popover-section">Click &lt;View Case&gt; to see the details on the case.</div>
  <div class="popover-section">Click &lt;Add To Cart&gt to add the case to the cart for printing or emailing.</div>
</ng-template>




// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/cart/cart.component.html